import r from "../managers/braze-instance.js";
import InAppMessage from "./models/in-app-message.js";
import je from "./in-app-message-manager-factory.js";
import { logInAppMessageImpression } from "./log-in-app-message-impression.js";
import { IamStrings as sr } from "./constants.js";
import { logger as E, EventTypes as f } from "../../shared-lib/index.js";
import ot from "../triggers/models/trigger-events.js";
import { TriggersProviderFactory as rt } from "../triggers/triggers-provider-factory.js";
export function logInAppMessageClick(s) {
  if (!r.rr()) return !1;
  if (!(s instanceof InAppMessage)) return E.error(sr.sS), !1;
  const e = je.ra().lt(s, f.zn);
  if (e) {
    s.sm() || logInAppMessageImpression(s);
    for (let r = 0; r < e.Ee.length; r++)
      rt.o().he(ot.rm, [s.triggerId], e.Ee[r]);
  }
  return e.W;
}
